import type { LayoutAssetReport, LayoutConstructor } from '../../libs/getAssetsToPreload';
import { getLayoutAssetsReport } from '../../libs/getAssetsToPreload';
import { getAllLayoutModules } from '../../libs/layouts/runtime/layoutModules';

type Module = Record<string, Record<string, unknown>>;

export async function generateAssetsLayoutReport(): Promise<void> {
  const modules = getAllLayoutModules();

  console.log(modules);

  const reports: Record<string, LayoutAssetReport> = {};

  await Promise.all(
    Object.keys(modules).map(async (path: string) => {
      const match = path.match(/([^\\/]+)\.[^\\/]+$/);
      const layoutName = match ? match[1] : null;

      if (!layoutName) return;

      const module = modules[path] as Module;
      const layoutCtr = module[layoutName] as unknown as LayoutConstructor;

      if (!layoutCtr) {
        console.warn(`cannot read ${layoutName} for some reason`);
        return;
      }

      console.log({ layoutName, layoutCtr, module });

      reports[layoutName] = getLayoutAssetsReport(layoutCtr);
    }),
  );

  const excludeAtlases = [
    'default',
    'game',
    'popups',
    'ui',
    'animations',
    'menu',
    'shop',
    'tournamentPage',
    'dailyReward',
    'shapes',
  ];

  const warnings: { layout: string; report: LayoutAssetReport; offenders: string[] }[] = [];

  Object.entries(reports).forEach(([layoutName, report]) => {
    const offenders = Object.entries(report.atlasesUse).filter(
      ([atlasName, uses]) => !excludeAtlases.includes(atlasName) && uses < 2,
    );
    if (offenders.length > 0) {
      warnings.push({ layout: layoutName, report, offenders: offenders.map(([atlas]) => atlas) });
    }
  });

  console.log({ reports, warnings });
}
